module.exports = __webpack_public_path__ + "img/dk.54fcc3ec.svg";